import { Badge as MuiBadge, BadgeProps as MuiBadgeProps } from '@material-ui/core';
import { Theme } from '@emotion/react';
import { badge } from 'omakase/Badge/badgeCssDefs';
import React from 'react';

export type BadgeSize = 'small' | 'medium' | 'large' | 'xLarge';
export type BadgePosition = 'topLeft' | 'topRight' | 'bottomRight' | 'bottomLeft';

interface BadgeBaseProps {
  /**
   * The size of the badge
   */
  size: BadgeSize;
}

export type BadgeProps = BadgeBaseProps & Pick<MuiBadgeProps, 'invisible' | 'badgeContent'>;

const Badge: React.FunctionComponent<BadgeProps> = ({
  children,
  invisible = false,
  size,
  badgeContent = undefined,
  ...rest
}) => {
  // Workaround for initial SSR render not being in sync with local state
  // (derived from enhanced stores, i.e., state stored in local storage or session storage)
  const [effectiveInvisible, setEffectiveInvisible] = React.useState(true);
  React.useEffect(() => {
    setEffectiveInvisible(invisible);
  }, [invisible]);

  return (
    <MuiBadge
      badgeContent={badgeContent}
      variant={badgeContent ? undefined : 'dot'}
      color="primary"
      css={(theme: Theme) =>
        badge(theme, size, { invisible: effectiveInvisible, hasContent: !!badgeContent })
      }
      invisible={effectiveInvisible}
      {...rest}
    >
      {children}
    </MuiBadge>
  );
};

export default Badge;
